import { utc } from '@date-fns/utc';
import { formatDate as fmt } from 'date-fns';
import type { DateArg } from 'date-fns';

export function formatDateTime<T extends Date>(date: DateArg<T>): string {
  return fmt(date, 'yyyy-MM-dd, HH:mm', { in: utc });
}

export function formatDate<T extends Date>(date: DateArg<T>, format: string = 'yyyy-MM-dd'): string {
  return fmt(date, format, { in: utc });
}

// In the time zone of the browser, for a view of what happens now. Records use the UTC variants.
export function formatLocalDate<T extends Date>(date: DateArg<T>, format: string = 'yyyy-MM-dd'): string {
  return fmt(date, format);
}

export function formatLocalDateTime<T extends Date>(date: DateArg<T>): string {
  return fmt(date, 'yyyy-MM-dd, HH:mm');
}

// Display variant with seconds, for surfaces where event ordering matters (MRV
// operations, cargo movements, etc.).
export function formatDateTimeWithSeconds<T extends Date>(date: DateArg<T>): string {
  return fmt(date, 'yyyy-MM-dd, HH:mm:ss', { in: utc });
}

// Copy/export variant — space-separated, no comma, which Excel parses straight
// into a datetime cell. Pair with `formatDateTimeWithSeconds` for display.
export function formatExcelDateTime<T extends Date>(date: DateArg<T>): string {
  return fmt(date, 'yyyy-MM-dd HH:mm:ss', { in: utc });
}
